<div [cdkTrapFocusAutoCapture]="autoFocus"
     [cdkTrapFocus]="autoFocus">
  <div tabindex="0"></div>
  <ng-content></ng-content>
</div>
